import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type Role = "superadmin" | "admin" | "employee";

export interface Me {
  userId: string;
  email: string;
  name: string | null;
  role: Role;
  isManager: boolean;
  isSuperadmin: boolean;
}

/**
 * The gate check. Everything in the app depends on this resolving, so it is the
 * one query that must not be retried into a hang — a 401/403 is an answer, not
 * a transient failure.
 */
export function useMe(enabled = true) {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api.get<Me>("/me"),
    enabled,
    // A 401/403 here is an answer, not a transient failure — retrying would
    // turn a clear "you are suspended" into a hang.
    retry: false,
    staleTime: 60_000,
  });
}
